import React from "react";
import MasterLayout from "../../../../masterLayout/MasterLayout";
import Breadcrumb from "../../../../components/Breadcrumb";
import ManageMemberLayer from "../../../components/Admin/ManageMemberLayer";

const ManageMember = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Add Category' />

        {/* BlankPageLayer */}
        <ManageMemberLayer />
      </MasterLayout>
    </>
  );
};

export default ManageMember;